<template>
    <thead :style="theadStyle" data-pc-section="thead">
        <tr role="row" data-pc-section="headerrow">
            <template v-if="showColumnAction">
                <editable-header-cell
                    :column="{ label: actionLabel, frozen: frozenColumnAction }"
                ></editable-header-cell>
            </template>
            <editable-header-cell
                v-for="(column, index) in columns"
                :key="`column_${index}`"
                :columnKey="column.columnKey"
                :column="column"
                v-bind="column.props"
            ></editable-header-cell>
        </tr>
    </thead>
</template>

<script>
import EditableHeaderCell from './EditableHeaderCell.vue';

export default {
    name: 'EditableTableHeader',
    components: {
        EditableHeaderCell
    },
    props: {
        showColumnAction: {
            type: Boolean,
            required: true
        },
        frozenColumnAction: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Array,
            required: true,
            default: () => [],
            validator: value => {
                return value.every(column => typeof column.label === 'string');
            }
        }
    },
    computed: {
        actionLabel() {
            return this.$tc('Shared.ActionsTxt', 2);
        },
        theadStyle() {
            let style = undefined;
            if (
                this.columns.some(
                    x => Object.prototype.hasOwnProperty.call(x, 'frozen') && x.frozen
                ) ||
                (this.showColumnAction && this.frozenColumnAction)
            ) {
                style = { position: 'sticky' };
            }

            return style;
        }
    }
};
</script>
